import { isNil } from 'lodash';
import { ReactNode } from 'react';
import { Text } from '@shared/components/Text';
import { View } from '@shared/components/View';
import { MBIconV2, MBIconV2Name } from '@shared/components/image';
import { grid } from '@shared/styles';
import styles from './RowContent.module.css';

const DEFAULT_ICON_SIZE = grid(3);

export interface RowContentProps {
  children?: ReactNode;
  label?: ReactNode;
  numberOfLines?: number;
  startContent?: ReactNode;
  // none shows an empty space next to the label, so it can align with other
  // menu items that have icons
  icon?: MBIconV2Name | 'none';
  iconSize?: number;
  endContent?: ReactNode;
}

export function RowContent({
  label,
  numberOfLines = 1,
  children,
  icon,
  iconSize = DEFAULT_ICON_SIZE,
  startContent,
  endContent,
}: RowContentProps) {
  const showStartContent = icon || startContent;
  const renderIcon = !isNil(icon) && icon !== 'none';
  return (
    <>
      {showStartContent && (
        <View className={styles.startContent} data-slot={'start'}>
          {!isNil(icon) && (
            <View className={styles.icon} data-slot="icon">
              {renderIcon && <MBIconV2 name={icon} size={iconSize} />}
            </View>
          )}
          {isNil(icon) && startContent}
        </View>
      )}
      {label && (
        <View className={styles.label} data-slot="label">
          <Text numberOfLines={numberOfLines} size="body1" data-slot="label-text">
            {label}
          </Text>
        </View>
      )}
      {!label && children}
      {endContent && (
        <View className={styles.endContent} data-slot="end">
          {endContent}
        </View>
      )}
    </>
  );
}
